import { Helper } from '../../../../../classes/helper'
import { LogBar } from '../../../../../classes/helper/logBar.class'
import { cover } from '../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../context/montage.context'
import { LogsBarModel } from '../../model/log/LogsBarModel'

interface Props {
  isBackLog?: boolean
}

export const LogsBarOuter = ({ isBackLog }: Props): JSX.Element => {
  const { measure, typ } = useMontage()

  const positionOuter = LogBar.positionOuter(
    measure.userWidth,
    cover.terraceCover.logBarOffset()
  )
  const width = typ?.width ?? 0
  const depth = typ?.depth ?? 0
  return (
    <>
      {[...Array(4)].map((_, index) => {
        return (
          <LogsBarModel
            key={index}
            isBackLog={isBackLog}
            position={[
              Helper.convertToMeter(
                (positionOuter - width / 2) * (index ? -1 : 1)
              ),
              Helper.convertToMeter(measure.frontHeight! / 2),
              Helper.convertToMeter(measure.userDepth! + depth / 2),
            ]}
          />
        )
      })}
    </>
  )
}
